export default __webpack_public_path__ + "static/media/InsideLungs_00.b3c6d05a.png";